Vue.component('product-card', {
    props: {
        currentProductId: Number,
        currentProductSizeId: Number,
        rawData: Array,
        sizePrice: Number,
        sizeOldPrice: Number,
        minimal: Number,
    },
    data() {
        return {
            productId: null,
            productSizeId: null,
            doughType: null,
            weight: null,
            count: 1,
            price: null,
            oldPrice: null,
            proteinsData: null,
            fatsData: null,
            carbohydrateData: null,
            dynamicParams: {

            }
        };
    },
    computed: {
        totalPrice() {
            return this.price * this.count;
        },
        doughTypeValue() {
            return this.dynamicParams['dough-' + this.currentProductId];
        },
        weightValue() {
            return this.dynamicParams['weight-' + this.currentProductId];
        }
    },
    methods: {
        getProduct() {
            return store.state.products[this.productSizeId];
        },
        setProductId(weight, doughType) {
            this.productSizeId = null;
            let candidate = null;
            let candidateIndex = null;
            for (let index in this.rawData) {
                let datum = this.rawData[index];
                if (datum.doughType == doughType) {
                    if (datum.weight == weight) {
                        candidate = datum;
                        this.productSizeId = +this.rawData[index].productSizeId;
                        candidateIndex = this.rawData[index].productSizeId;
                        break;
                    } else {
                        candidate = datum;
                        candidateIndex = this.rawData[index].productSizeId;
                    }
                }

            }

            this.dynamicParams['dough-' + this.currentProductId] = doughType;
            this.dynamicParams['weight-' + this.currentProductId] = weight;
            if (this.productSizeId === null) {
                this.productSizeId = +candidateIndex;
                this.dynamicParams['weight-' + this.currentProductId] = candidate.weight;
            }

            this.price = store.state.products[this.productSizeId].price;
            this.oldPrice = store.state.products[this.productSizeId].old_price;
            if (this.$el.querySelector('.product__price--prev')) {
                this.$el.querySelector('.product__price--prev').innerText = this.oldPrice !== null ? this.oldPrice + ' руб' : ''
            }
            this.$el.querySelector('.product__price--now').innerText = this.price !== null ? this.price + ' руб' : ''

            let _this = this;
            this.count = store.state.order.items.reduce(function (value, item) {
                if (item.product.id == _this.productSizeId) {
                    return item.count;
                }
                return value;
            }, this.minimal);
        },
        isAvailableWeight(weight) {
            for (let index in this.rawData) {
                let datum = this.rawData[index];
                if (datum.doughType == this.doughType && datum.weight == weight) {
                    return true;
                }
            }
            return false;
        },
        changeWeight(weight) {
            this.setProductId(weight, this.doughTypeValue);
        },
        changeDoughType(type) {
            this.setProductId(this.weightValue, type);
        },
        addInCart() {
            let quantity = store.getters.getProductQuantity(this.productSizeId);
            quantity = quantity === 0 ? 1 : quantity + 1;
            try {
                fbq('track', 'AddToCart', {
                    value: this.price * quantity, //коллчиество пирогов
                    currency: 'RUB', // RUR - так нужно значение сделать
                    contents: [
                        {
                            id: this.productSizeId, // ID ТОВАРОА
                            quantity: quantity // КОЛЛИЧЕСТВО ТОВАРА
                        }
                    ],
                });
            } catch (e) {}
            store.dispatch('setItemInCart', {product_id: this.productSizeId, count: quantity});
        },
        addItems() {
            this.count = ProductHelper.changeCount(this.getProduct(), this.count + 1);
        },
        reduceItems() {
            if (this.count > 1) {
                this.count = ProductHelper.changeCount(this.getProduct(), this.count - 1, true);
            }
        },
        changeItems() {
            this.count = ProductHelper.changeCount(this.getProduct(), this.count);
        },
        changeCount(direction) {
            let newCount = this.count + direction;
            if (newCount < this.minimal) {
                newCount = this.minimal;
            }
            this.count = newCount;
        },
        formatPrice(price) {
            return NumberHelper.format(price);
        },
        setActiveLink() {
            const hash = window.location.hash;
            document.querySelectorAll('.header__link').forEach(link => {
                link.classList.remove('header__link_active');
                if (link.getAttribute('href') === `/${hash}`) {
                    link.classList.add('header__link_active');
                }
            });
            document.querySelectorAll('.menu__link').forEach(link => {
                link.classList.remove('menu__link_active');
                if (link.getAttribute('href') === `/${hash}`) {
                    link.classList.add('menu__link_active');
                }
            });
        }
    },
    created() {
        if (this.rawData.length > 0) {
            this.$set(this.dynamicParams, 'dough-' + this.currentProductId, this.rawData[0].doughType);
            this.$set(this.dynamicParams, 'weight-' + this.currentProductId, this.rawData[0].weight);
        }
        this.productSizeId = this.currentProductSizeId;
        this.productId = this.currentProductId;

        this.price = this.sizePrice;
        this.count = this.minimal;
        this.oldPrice = this.sizeOldPrice;
    },
    mounted() {
        const products = this.$el.querySelectorAll('.js-add-button');
        products.forEach(function (item) {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();
                const isInteractive = e.target.closest('button, .btn, input, label');
                if (!isInteractive) {
                    const url = this.$el.href;
                    if (url) {
                        window.location.href = url;
                    }
                }
            });
        });
        const buttonArea = this.$el.querySelectorAll('.product__options-group');
        buttonArea.forEach(function (item) {
            item.addEventListener('click', (e) => {
                if (e.target.classList.contains('product__options-group')) {
                    e.preventDefault();
                }
            });
        });
        this.setActiveLink();

        window.addEventListener('hashchange', this.setActiveLink);
    }
});

